module.exports = __webpack_public_path__ + "img/manda_038.3a423a7e.png";